<template>
    <div class="container edit-profile-page">
        <div v-if="logoutSplash" class="logout-splash">
            <span>{{ logoutMessage }}</span>
        </div>

        <div class="edit-shell mt-11">
            
            <div class="edit-card profile-card mt-13">
                <p class="text-white">
                    Complete your profile information to enjoy a seamless experience and increase your visibility to potential clients.
                </p>
                <div class="edit-hero mt-5">
                    <button type="button" class="back-link" @click="backProfile()">
                        <img src="../assets/arrow-back.png" alt="" width="22" height="22">
                        <span>Back to profile</span>
                    </button>
                </div>
                <div class="profile-upload mt-14">
                    <div
                        @click="$refs.fileInput.click()"
                        class="avatar-picker"
                        :style="escort_data.profilepic || previewImage ? { 'background-image': `url(${previewImage || escort_data.profilepic})` } : {}"
                    >
                        <input
                            type="file"
                            ref="fileInput"
                            id="image_input"
                            class="w-px h-px opacity-0 overflow-hidden absolute"
                            accept="image/png, image/jpg, image/jpeg"
                            style="cursor:pointer"
                            @change="pickFile"
                        />
                    </div>

                    <div class="profile-upload-copy">
                        <h4>{{ username }}</h4>
                        <p>Tap the photo to upload a new profile image.</p>
                    </div>
                </div>

                <div class="profile-summary">
                    <div class="summary-item">
                        <span class="summary-label">Email</span>
                        <strong>{{ email }}</strong>
                    </div>
                    <div class="summary-item">
                        <span class="summary-label">Phone</span>
                        <strong>{{ phone }}</strong>
                    </div>
                    <!-- <div class="summary-item">
                        <span class="summary-label">Profile ID</span>
                        <strong>{{ userid }}</strong>
                    </div> -->
                </div>
            </div>

            <div class="edit-card form-card mt-11">
                <input type="hidden" class="input-textx" v-model="userid">

                <div class="form-grid">
                    <div class="field-group field-group--full">
                        <span class="label">Full name</span>
                        <input type="text" class="field-control" v-model="fullname" placeholder="Enter your full name">
                    </div>

                    <div class="field-group field-group--full">
                        <span class="label">Slogan</span>
                        <input type="text" class="field-control" v-model="slogan" placeholder="A short line that describes you">
                    </div>

                    <div class="field-group">
                        <span class="label">Phone</span>
                        <input type="text" class="field-control field-control--readonly" v-model="phone" readonly>
                    </div>

                    <div class="field-group">
                        <span class="label">Gender</span>
                        <select v-model="gender" class="field-control field-select">
                            <option value="">Select gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>

                    <div class="field-group">
                        <span class="label">Country</span>
                        <input type="text" class="field-control" v-model="country" placeholder="Country">
                    </div>

                    <div class="field-group">
                        <span class="label">Location</span>
                        <input type="text" class="field-control" v-model="location" placeholder="Area or city">
                    </div>

                    <div class="field-group">
                        <span class="label">Email</span>
                        <input type="email" class="field-control field-control--readonly" v-model="email" readonly>
                    </div>

                    <div class="field-group">
                        <span class="label">State</span>
                        <v-autocomplete
                            class="field-control field-control--autocomplete"
                            v-model="state"
                            :items="options"
                        ></v-autocomplete>
                    </div>

                    <div class="field-group field-group--full">
                        <span class="label">Birthday</span>
                        <div class="birthday birthday-grid">
                            <select v-model="day" class="field-control field-select">
                                <option value="">Day</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                            </select>

                            <select v-model="month" class="field-control field-select">
                                <option value="">Month</option>
                                <option value="01">January</option>
                                <option value="02">February</option>
                                <option value="03">March</option>
                                <option value="04">April</option>
                                <option value="05">May</option>
                                <option value="06">June</option>
                                <option value="07">July</option>
                                <option value="08">August</option>
                                <option value="09">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>

                            <select id="years" class="field-control field-select" v-model="year">
                                <option value="">Year</option>
                                <option v-for="year in yearsList" :key="year" :value="year">
                                    {{ year }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="field-group field-group--full">
                        <span class="label">About you</span>
                        <textarea
                            v-model="aboutyou"
                            cols="40"
                            rows="6"
                            class="field-control field-textarea"
                            placeholder="Tell us a bit about yourself"
                        ></textarea>
                    </div>
                </div>

                <div class="button-container">
                    <button class="btn-save" @click="save()">
                        Save changes
                        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="splashScreen">
            <transition name="modal" >
                <div class="modal-mask">
                    <div class="modal-wrapper col-md-4" style="margin:auto">
                        <!-- <div class="modal-dialog modal-xl"> -->
                            <div class="profile-view2">
                                <hr style="color:#3E3D3D; margin-top:-20px">
                                <span class="profile-bio2">
                                     <p style="font-size:x-large">
                                        <i class="fas fa-spinner"></i> Processing...
                                     </p>
                                </span>
                            </div>
                        <!-- </div> -->
                    </div>
                </div>
            </transition>
        </div> 
        <div class="loader" v-if="pageLoader">
            <span class="dot"></span> 
            <span class="dot"></span>
            <span class="dot"></span>
        </div>

        <v-dialog v-model="showImageDialog" max-width="800px">
        <v-card>
            <v-img :src="selectedImage" aspect-ratio="1.5" contain></v-img>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="pink darken-1" @click="showImageDialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>

//import userInterests from '../components/UserInterests';
import swal from 'sweetalert2';
export default {

    components: {
        //userInterests,        
    },
    
    data() {
    return {
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        profile: true,
        edit_profile: false,
        btn_success: false,
        previewImage:'',
        previewImage2: '',
        myprofile: '',
        age: '',
        fullname: '',
        firstname:'',
        middlename: '',
        lastname: '',
        username: '',
        email: '',
        phone: '',
        day: '',
        month: '',
        year: '',
        gender: '',
        location: '',
        state: '',
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
        loading2: false,
        musicx: '',
        dancex: '',
        foodx: '',
        fashionx: '',
        photographyx: '',
        travelx: '',
        cookingx: '',
        userphoto: '',
        country: '',
        profile_pictures:[],
        options: [],
        transport: '',
        activeTab: 'gallery',
        tabs: [
            { name: 'gallery', label: 'Gallery' },
            { name: 'videos', label: 'Videos' },
            { name: 'rate', label: 'Rates' },
            { name: 'preferences', label: 'Preferences' },
            { name: 'review', label: 'Review' },
            { name: 'follows', label: 'Followers' }
        ],
        pricingOptions: [
        { value: "negotiable", text: "Negotiable" },
        { value: "5k", text: "₦5,000" },
        { value: "10k", text: "₦10,000" },
        { value: "15k", text: "₦15,000" },
        { value: "premium", text: "₦20,000 and above" },
        ],

        options3: [

            {
                value: "Gay",
                text: "Gay",
            },
            {
                value: "Lesbian",
                text: "Lesbian",
            },
            {
                value: "Bisexual",
                text: "Bisexual",
            },
            {
                value: "Straight",
                text: "Straight",
            },
            {
                value: "I'd prefer not to say",
                text: "I'd prefer not to say",
            },
        ],
        options4: [
        {
            value: "My fare must be covered",
            text: "My fare must be covered",
        },
        {
            value: "I'll find my own way there",
            text: "I'll find my own way there",
        },
        {
            value: "I prefer to be picked up",
            text: "I prefer to be picked up",
        },
        {
            value: "I'll need return fare too",
            text: "I'll need return fare too",
        },
        {
            value: "Only available within my area",
            text: "Only available within my area",
        }
        ],

        options5: [

            {
                value: "3",
                text: "3 Months",
            },
            {
                value: "6",
                text: "6 Months",
            },
            {
                value: "12",
                text: "One Year",
            },
            
        ],
        photos: '',
        profile_photo: '',
        userid: '',
        escort_data: '',
        yearsList: [],
        profilePictureFile: null,
        slogan: '',
        logoutSplash: false,
        logoutMessage: ""
        };
    },

beforeMount(){
    this.userid =  this.$route.params.escortid;
    this.editProfile(this.userid);
    this.getStates()
   // this.checkUserProfilePhotoAndPhoto();
},

mounted(){
    // Populate years list when component mounts
    this.generateYears();
},

methods: {
    
    generateYears() {
      const start = 1940;
      const end = new Date().getFullYear();
      for (let i = start; i <= end; i++) {
        this.yearsList.push(i);
      }
    },

    backProfile() {
    // Go to previous page
    this.$router.go(-1);
    },
    async pickFile() {
        let input = this.$refs.fileInput;
        let file = input.files;
        
        if (file && file[0]) {
            let reader = new FileReader();
            
            reader.onload = (e) => {
            this.previewImage = e.target.result; // Show image preview
            this.profilePictureFile = file[0];   // Correct assignment of File object
            };

            reader.readAsDataURL(file[0]);

            this.$emit("input", file[0]);  // Optional: for parent components
            this.btn_success = true;       // Enable save button or mark success
        }
    },

    async editProfile(userid){
        const response = await this.$http.post('/list-profile',{ user_id: userid}, {
            headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
            } )
            this.escort_data = response.data.data[0];
           const birthday = this.escort_data.birthday?.split('-');
            this.username = this.escort_data.username,
            this.fullname= this.escort_data.name,
            this.email = this.escort_data.email_address,
            this.phone = this.escort_data.phone_number,
            this.day = birthday[2]?.split("T")[0],
            this.month = birthday[1],
            this.year = birthday[0],
            this.gender = this.escort_data.gender,
            this.country = this.escort_data.country,
            this.state = this.escort_data.state,
            this.location = this.escort_data.location,
            this.aboutyou = this.escort_data.bio,
            this.slogan = this.escort_data.slogan
    },
    async getStates() {
    try{
        const response = await this.$http.get('/state/fetch', {
            headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
        } )

        response.data.states.forEach((el) => {
        this.options.push({
          value: el.state,
          text: el.state,
        });

      });
               
        }catch (err) {
            console.log(err);
        }
    },
    
    async save() {
    try {
        // Optional: Validate required fields (can be more tailored)
        if (!this.fullname || !this.email || !this.phone) {
         // Set splash message
         this.logoutMessage = "Please fill all required fields.";
         this.logoutSplash = true;
        // Wait before redirecting
         setTimeout(() => {
         this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds
        return;
        }

        this.loading = true;

        // Format birthday
        const birthday = `${this.year}-${this.month}-${this.day}`;

        // Build FormData for submission
        const formData = new FormData();
        formData.append('userid', this.userid);
        formData.append('fullname', this.fullname);
        formData.append('phone', this.phone);
        formData.append('gender', this.gender);
        formData.append('email', this.email);
        formData.append('birthday', birthday);
        formData.append('country', this.country);
        formData.append('state', this.state);
        formData.append('location', this.location);
        formData.append('aboutyou', this.aboutyou);
        formData.append('slogan', this.slogan);

        // Add image file if selected
        if (this.profilePictureFile) {
          formData.append('profile_picture', this.profilePictureFile);
        }

        // Send request
        const response = await this.$http.post('/update-profile', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        this.loading = false;

        if (response.data.success) {
        // Set splash message
        this.logoutMessage = response.data.message || "Successful!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
        this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds

        // Optional: Clear or redirect
        this.$router.go(-1);
        } else {
        swal.fire({
            icon: 'warning',
            width: 450,
            text: response.data.message,
        });
        }
    } catch (err) {
        console.error(err);
        this.loading = false;
        swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: err.response ? err.response.data.message : err.message,
        });
    }
    },
  }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}

.nav-link{
    color: #D33E74;
}
 .nav-tabs .nav-link {
    cursor: pointer;
 }

    .nav-tabs .nav-link.active {
        background-color: #D33E74;
        color: white;
        border-radius: 0.25rem;
    }

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
  
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
   }
.content-fluid {
    background: transparent;
}
.container {
    margin-top: 80px;
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;


    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
         padding: 0 0 0 20px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 25px;
            line-height: 20px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            line-height: 20px;
            text-align: left;
            color: #FFFFFF;
        }        
    }
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 120px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0 solid;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-phone{
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
  .input-gender{
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text-about{
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
   
 }
 .phonegender{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{

    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 100px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}
}

/* Modern edit profile layout */
.edit-profile-page {
    margin-top: 0;
    padding: 32px 16px 64px;
    min-height: 100vh;
    background:
        radial-gradient(circle at top left, rgba(211, 62, 116, 0.2), transparent 28%),
        radial-gradient(circle at top right, rgba(255, 138, 0, 0.12), transparent 26%),
        linear-gradient(180deg, #09070d 0%, #0f0b14 100%);
}

.edit-shell {
    width: min(1120px, 100%);
    margin: 0 auto;
    display: grid;
    grid-template-columns: minmax(280px, 0.78fr) minmax(0, 1.22fr);
    gap: 20px;
    align-items: start;
}

.edit-hero,
.edit-card {
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(14, 11, 20, 0.82);
    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.34);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-radius: 28px;
}

.edit-hero,
.edit-card {
    padding: 26px;
}

.edit-hero {
    display: flex;
    flex-direction: column;
    gap: 22px;
}

.edit-hero::before,
.edit-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), transparent 34%);
    pointer-events: none;
}

.back-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
    padding: 10px 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.03);
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.01em;
    transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.back-link:hover {
    transform: translateY(-1px);
    border-color: rgba(211, 62, 116, 0.45);
    background: rgba(211, 62, 116, 0.12);
}

.edit-hero-copy {
    display: grid;
    gap: 12px;
}

.eyebrow {
    margin: 0;
    color: #ffbfd2;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
}

.edit-hero h1 {
    margin: 0;
    color: #fff;
    font-family: 'Raleway', sans-serif;
    font-size: clamp(30px, 3.2vw, 42px);
    line-height: 1.05;
    letter-spacing: -0.03em;
}

.hero-text {
    margin: 0;
    max-width: 38ch;
    color: rgba(255, 255, 255, 0.72);
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    line-height: 1.7;
}

.edit-hero-stats {
    display: grid;
    gap: 12px;
}

.stat-chip {
    display: grid;
    grid-template-columns: 44px 1fr;
    gap: 12px;
    align-items: center;
    padding: 14px 16px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(255, 255, 255, 0.04);
}

.stat-chip i {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    color: #fff;
    font-size: 16px;
    background: linear-gradient(135deg, #d33e74, #ff8a00);
    box-shadow: 0 14px 28px rgba(211, 62, 116, 0.2);
}

.stat-chip strong {
    display: block;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    margin-bottom: 2px;
}

.stat-chip span {
    display: block;
    color: rgba(255, 255, 255, 0.62);
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
}

.profile-upload {
    display: flex;
    align-items: center;
    gap: 18px;
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.avatar-picker {
    width: 112px;
    height: 112px;
    flex: 0 0 112px;
    border-radius: 50%;
    border: 3px solid rgba(211, 62, 116, 0.75);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(0, 0, 0, 0.24)), url("../assets/no_image.png");
    background-size: cover;
    background-position: center;
    box-shadow: 0 18px 32px rgba(0, 0, 0, 0.22);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.avatar-picker:hover {
    transform: translateY(-2px) scale(1.01);
    box-shadow: 0 20px 34px rgba(0, 0, 0, 0.28);
}

.profile-upload-copy h4 {
    margin: 0 0 6px;
    color: #fff;
    font-family: 'Raleway', sans-serif;
    font-size: 24px;
    line-height: 1.15;
}

.profile-upload-copy p {
    margin: 0;
    color: rgba(255, 255, 255, 0.68);
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    line-height: 1.6;
}

.profile-summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.summary-item {
    padding: 14px 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.summary-label {
    display: block;
    margin-bottom: 6px;
    color: rgba(255, 255, 255, 0.56);
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.summary-item strong {
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    word-break: break-word;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.field-group {
    display: grid;
    gap: 8px;
}

.field-group--full {
    grid-column: 1 / -1;
}

.field-control {
    width: 100%;
    min-height: 48px;
    padding: 12px 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.04);
    color: #fff !important;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.field-control::placeholder {
    color: rgba(255, 255, 255, 0.34);
}

.field-control:focus,
.field-select:focus,
.field-textarea:focus {
    border-color: rgba(211, 62, 116, 0.65);
    box-shadow: 0 0 0 4px rgba(211, 62, 116, 0.12);
    background: rgba(255, 255, 255, 0.06);
}

.field-control--readonly {
    opacity: 0.82;
    cursor: not-allowed;
}

.field-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: #706f6f !important;
}

.field-textarea {
    resize: vertical;
    min-height: 136px;
}

.birthday-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 22px;
}

.btn-save {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: 48px;
    padding: 0 22px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(135deg, #d33e74 0%, #ff6f61 100%);
    color: #fff;
    font-family: 'Raleway', sans-serif;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.01em;
    box-shadow: 0 16px 30px rgba(211, 62, 116, 0.24);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.btn-save:hover {
    transform: translateY(-1px);
    filter: brightness(1.03);
    box-shadow: 0 20px 36px rgba(211, 62, 116, 0.3);
}

::v-deep .field-control--autocomplete .v-input__slot {
    min-height: 48px !important;
    padding: 0 4px !important;
    border-radius: 16px !important;
    background: transparent !important;
    box-shadow: none !important;
}

::v-deep .field-control--autocomplete .v-input__control,
::v-deep .field-control--autocomplete .v-text-field__details {
    margin: 0 !important;
    padding: 0 !important;
}

::v-deep .field-control--autocomplete input {
    color: #fff !important;
    font-family: 'DM Sans', sans-serif !important;
    font-size: 14px !important;
}

::v-deep .field-control--autocomplete .v-icon {
    color: rgba(255, 255, 255, 0.7) !important;
}

@media screen and (max-width: 992px) {
    .edit-shell {
        grid-template-columns: 1fr;
    }
}

@media screen and (max-width: 768px) {
    .edit-profile-page {
        padding: 18px 12px 36px;
    }

    .edit-hero,
    .edit-card {
        border-radius: 22px;
        padding: 18px;
    }

    .profile-upload {
        flex-direction: column;
        align-items: flex-start;
    }

    .profile-summary,
    .form-grid,
    .birthday-grid {
        grid-template-columns: 1fr;
    }

    .field-group--full,
    .birthday-grid,
    .summary-item {
        grid-column: auto;
    }

    .btn-save {
        width: 100%;
        min-width: 0;
    }

    .button-container {
        justify-content: stretch;
    }
}

</style>
